import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import { SelectGeneralApplicationComponent } from 'app/modules/landing/corporate/select-general-application/select-general-application.component';
import { MobileComponent } from '../application-dash/mobile/mobile.component';
import { Draft } from '../interfaces/draft';
import { ApplicationDashboardService } from '../services/application-dashboard.service';
import { TranslateModule } from '@ngx-translate/core';
import { ApplicationHeaderComponent } from '../application-header/application-header.component';
import { LoaderComponent } from 'app/components/loader/loader.component';
import { ConfirmInfoComponent } from 'app/modules/landing/corporate/business-info/confirm-info/confirm-info.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-application-draft',
    templateUrl: './application-draft.component.html',
    styleUrls: ['./application-draft.component.scss'],
    imports: [
        CommonModule,
        HeaderComponent,
        FooterComponent,
        MatIconModule,
        SelectGeneralApplicationComponent,
        MobileComponent,
        MatCheckboxModule,
        FormsModule,
        RouterModule,
        TranslateModule,
        ApplicationHeaderComponent,
        ConfirmInfoComponent,
        LoaderComponent,
    ],
    standalone: true,
    styles: [
        `
            :host {
                width: 100%;
            }
        `,
    ],
})
export class ApplicationDraftComponent implements AfterViewInit {
    deleteDraftMsg = false;
    dropDown = false;
    drafts: Draft[] = [];
    clickedOutside: boolean = false;
    isAuthenticated: boolean;
    apiResponse: boolean = false;
    selectedLanguage: any;
    isMatchedProductsFlow = false;
    getQType;
    appProductFlow: any;

    constructor(
        private cdr: ChangeDetectorRef,
        private _dashboardService: ApplicationDashboardService,
        private router: Router,
        public dialog: MatDialog
    ) {
        this.selectedLanguage = localStorage.getItem('language');
        this.isAuthenticated =
            localStorage.getItem('isAuthenticated') == 'true' ? true : false;
        if (this.isAuthenticated == false) {
            this.router.navigate(['/login']);
        }
    }

    ngAfterViewInit(): void {
        this.getCaseDrafts();
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
    }

    // fetch drafts from api
    getCaseDrafts() {
        this.drafts = [];
        this._dashboardService.getDrafts().subscribe({
            next: (data) => {
                this.apiResponse = true;
                const extraValues = {
                    selected: false,
                    drop: false,
                };
                data.filelist.map((item) => {
                    let draftObject = { ...item, ...extraValues };
                    this.drafts.push(draftObject);
                });

                data.filelist.forEach((element) => {
                    this.getQType = element.qType;
                });
                this.checkProductFlow(this.getQType);

                this.drafts.sort((a, b) => {
                    const dateA = new Date(a.updatedDateTime).getTime();
                    const dateB = new Date(b.updatedDateTime).getTime();
                    return dateB - dateA;
                });
            },
            error: (err) => {
                this.apiResponse = true;
            },
        });
    }

    // dropdown
    showDropdown(draft: any): void {
        //NOT USED IN HTML AND NOT CALLED IN TS ITSELF
        this.drafts.forEach((item) => {
            if (item.caseId == draft.caseId) {
                item.drop = !draft.drop;
            }
        });
    }

    // convert to ui date format
    formatDate(inputDate: any) {
        const months = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ];

        const date = new Date(inputDate);
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();

        return `${day} ${month} ${year} ${hours}:${minutes}:${seconds}`;
    }

    // select using checkbox
    public selectAll = false;
    toggleAllCheckboxes() {
        this.selectAll = !this.selectAll;
        this.drafts.forEach((item) => (item.selected = this.selectAll));
        this.checkDelBtn();
    }
    public deleteBtn = false;
    toggleSelection(item: any) {
        for (const draft of this.drafts) {
            if (item.caseId === draft.caseId) {
                draft.selected = !item.selected;
            }
        }
        this.checkSelectAll();
        this.checkDelBtn();
        this.cdr.detectChanges();
    }

    checkDelBtn() {
        let tempdel = false;
        for (const draft of this.drafts) {
            if (draft.selected) {
                tempdel = true;
                break;
            }
        }
        this.deleteBtn = tempdel ? true : false;
    }

    checkSelectAll() {
        this.selectAll = this.drafts.every(item => item.selected);
    }

    // delete draft
    deleteDraft() {
        const draftIds: string[] = [];
        this.drafts.forEach((item) => {
            if (item.selected == true) {
                draftIds.push(String(item.caseId));
            }
        });
        const data = {
            draftlist: draftIds.map((ids) => Number.parseInt(ids)),
        };
        this._dashboardService.deleteDrafts(data).subscribe((data) => {
            this.deleteBtn = false;
            this.deleteDraftMsg = true;
            setTimeout(() => {
                this.deleteDraftMsg = false;
            }, 2000);
            this.getCaseDrafts();
        });
    }

    getStepNo(qType: string) {
        if (qType === 'LOAN_CGCP_ND_ANLS' || qType === 'LOAN_CGC_ND_ANLS') {
            // LOAN_CGCP_ND_ANLS set product flow, LOAN_CGC_ND_ANLS check matching products create case no need fr brn/kyc verified or not
            return 1;
        }
        if (qType === 'LOAN_CGCP_CHK_CNSN' || qType === 'LOAN_CGC_CHK_CNSN') {
            return 1;
        }
        if (qType === 'LOAN_CGCP_USR_INFO' || qType === 'LOAN_CGC_USR_INFO') {
            return 1;
        }

        if (
            qType === 'LOAN_CGCP_UPD_USR_INFO' ||
            qType === 'LOAN_CGC_UPD_USR_INFO'
        ) {
            // LOAN_CGC_UPD_USR_INFO or LOAN_CGCP_UPD_USR_INFO is for both kyc brn verified and financing info all fields are filled and financing info submitted
            return 2;
        }

        if (qType === 'LOAN_CGCP_BSNS_INFO' || qType === 'LOAN_CGC_BSNS_INFO') {
            //both check-eligibility/matched products submitted till business info only
            return 3;
        }

        if (
            qType === 'LOAN_CGC_FI_OFFR_SCR' ||
            qType === 'LOAN_CGCP_chk_elig'
        ) {
            //redirect to check-eligibility/matched products as business info is submitted already
            return 4;
        }
        if (qType === 'LOAN_CGC_UPLD_DOC' || qType === 'LOAN_CGCP_UPLD_DOC') {
            //redirect to check-eligibility/matched products as doc upload is save as draft
            return 5;
        }
    }

    checkProductFlow(qType) {
        const matchedProductsFlowArr = [
            'LOAN_CGC_CHK_CNSN',
            'LOAN_CGC_USR_INFO',
            'LOAN_CGC_UPD_USR_INFO',
            'LOAN_CGC_ND_ANLS',
            'LOAN_CGC_BSNS_INFO',
            'LOAN_CGC_FI_OFFR_SCR',
            'LOAN_CGC_UPLD_DOC',
        ];
        const selectProductFlowArr = [
            'LOAN_CGCP_CHK_CNSN',
            'LOAN_CGCP_USR_INFO',
            'LOAN_CGCP_UPD_USR_INFO',
            'LOAN_CGCP_ND_ANLS',
            'LOAN_CGCP_BSNS_INFO',
            'LOAN_CGCP_chk_elig',
            'LOAN_CGCP_UPLD_DOC',
        ];
        let getAppProductFlow; //coming from api if app is resumed
        if (matchedProductsFlowArr.includes(qType)) {
            getAppProductFlow = 'checkMatchingProducts';
            this.isMatchedProductsFlow = true;
        } else if (selectProductFlowArr.includes(qType)) {
            getAppProductFlow = 'selectProduct';
            this.isMatchedProductsFlow = false;
        }
        this.appProductFlow = getAppProductFlow;
    }

    async resume(
        caseId: string,
        qType: string,
        selectedProduct: string,
        productName: any
    ) {
        const navigationExtras = {
            state: {
                fromResume: true,
            },
        };
        if (this.appProductFlow == 'checkMatchingProducts') {
            navigationExtras.state['checkMatchingProduct'] = true;
        }

        if (this.getStepNo(qType) == 1) {
            navigationExtras.state['setProductDetails'] = caseId;
            navigationExtras.state['productName'] = productName;
            this.router.navigate(['/corporate'], navigationExtras);
        } else if (this.getStepNo(qType) == 2) {
            navigationExtras.state['caseId'] = caseId;
            this.router.navigate(['/business-info'], navigationExtras);
        } else if (this.getStepNo(qType) == 3) {
            navigationExtras.state['caseId'] = caseId;
            this.router.navigate(['/business-info'], navigationExtras);
        } else if (this.getStepNo(qType) == 4 || this.getStepNo(qType) == 5) {
            //check-eligibility or matched products flow
            let productFlowData = {
                caseId: caseId,
                prodCode: selectedProduct,
                productFlow: this.isMatchedProductsFlow,
            };
            navigationExtras.state['productFlowData'] = productFlowData;
            this.router.navigate(['/business-info'], navigationExtras);
        } else {
            navigationExtras.state['productName'] = productName;
            navigationExtras.state['caseId'] = caseId;
            this.router.navigate(['/corporate'], navigationExtras);
        }
    }

    changeMenuCondition(event: any) {
        this.clickedOutside = false;
    }

    closeMegaMenuCondition() {
        this.clickedOutside = !this.clickedOutside;
    }

    totalSelected(): number {
        let noOfSelectedDraft = 0;
        this.drafts.forEach((item) => {
            if (item.selected === true) {
                noOfSelectedDraft++;
            }
        });
        return noOfSelectedDraft;
    }

    getResumeColor() {
        return '#4B6EEC';
    }
}
